import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { useUnit } from 'effector-react';
import {
  $mapLoaded,
  resetMapLoadedEv,
  setMapLoadedEv,
} from '../../models/mapModel/index.js';
import CH_popup from '../../assets/CH_popup.png';
import ch_mobile_popup from '../../assets/ch_mobile_popup.png';
import ch_mobile_popup_active from '../../assets/ch_mobile_popup_active.png';

mapboxgl.accessToken =
  'pk.eyJ1IjoiZnJvbnRpZXJkIiwiYSI6ImNrYTNuMjBvNjAxNnAzbW85N3ZsbmRvZmYifQ.9OWZ7YWGJ4DDIV4bCTwsaA';

function Map() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const setMapLoaded = useUnit(setMapLoadedEv);
  const resetMapLoaded = useUnit(resetMapLoadedEv);

  useEffect(() => {
    if (mapRef.current) return;
    window.map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [65.7133351434909, 46.271747202152454],
      zoom: 4,
      projection: 'globe',
    });
    mapRef.current = window.map;
    window.map.dragRotate.disable();

    window.map.on('style.load', () => {
      window.map.loadImage(CH_popup, (error, image) => {
        if (error) throw error;
        window.map.addImage('popup', image, {
          stretchX: [
            [25, 55],
            [85, 115],
          ],
          stretchY: [[25, 100]],
          content: [25, 25, 115, 100],
          pixelRatio: 2,
        });
      });
      window.map.loadImage(ch_mobile_popup, (error, image) => {
        if (error) throw error;
        window.map.addImage('mobile_popup', image, {
          content: [6, 4, 78, 32],
        });
      });
      window.map.loadImage(ch_mobile_popup_active, (error, image) => {
        if (error) throw error;
        window.map.addImage('mobile_popup_active', image, {
          content: [6, 4, 78, 32],
        });
      });

      setMapLoaded(true);
    });

    return () => {
      resetMapLoaded();
      delete window.map;
      mapRef.current?.remove();
      mapRef.current = null;
    };
  }, []);

  // FIXME Part that adds draw polygon functionality. Maybe usefull later
  // useEffect(() => {
  //   if (mapLoaded && Object.keys(userInfo).length > 0 && !window.draw) {
  //     const Draw = new MapboxDraw({
  //       displayControlsDefault: false,
  //       controls: {
  //         polygon: true,
  //         point: true,
  //         trash: true,
  //       },
  //       // FIXME Custom styles of points and polygons MADE BY controls
  //       // for ref look in geo
  //       styles: userInfo.dark_theme ? customStylesDark : customStylesLight,
  //     });
  //
  //     window.draw = Draw;
  //
  //     const drawControls = new ExtendDrawBar({
  //       draw: Draw,
  //       buttons: [
  //         {
  //           on: 'click',
  //           action: deleteAll,
  //           classes: ['mapbox-gl-draw_ctrl-draw-btn', 'mapbox-gl-draw_trash'],
  //         },
  //       ],
  //     });
  //
  //     const { modes } = MapboxDraw;
  //     // modes.simple_select.onDrag = function (state, e) {};
  //
  //     if (window.map._controls.length != 3) {
  //       window.map.addControl(drawControls, 'bottom-left');
  //     }
  //
  //     window.addEventListener('keyup', (e) => {
  //       if (window.draw.getMode() !== 'simple_select' && e.key === 'Escape') {
  //         window.draw.changeMode('simple_select');
  //       }
  //     });
  //     window.map.on('draw.modechange', modeChangeHandler);
  //     window.map.on('draw.create', createObject);
  //     window.map.on('draw.delete', deleteAll);
  //     window.map.on('draw.update', updatePolygon);
  //   }
  // }, [userInfo, mapLoaded]);

  return <div ref={mapContainer} className="map-container" />;
}

export default Map;
